import * as React from 'react';
import * as I18n from 'i18n-js';
import track from 'react-tracking';

import CoreLink from '../../components/core_link';
import { randSample } from '../../random';
import { withUserContext, IUserContext } from '../../components/user_context_provider';
import { CORE_MARKETPLACE_URL, marketplaceQuery } from '../../url_helpers';
import CMSSearchInputGroup from '../../components/cms_search_input_group';
import SanitizedRender from '../../components/sanitized_render';

const defaultValues = [
  '1964 Fender Stratocaster',
  'Elektron Digitakt',
  'Fender Precision Bass',
  'Fulltone OCD',
  'Gibson Les Paul Custom',
  'Ibanez Tube Screamer',
  'Ludwig Black Beauty Snare',
  'Ludwig Jazz Festival Snare',
  'Marshall JCM800',
  'Moog Model D Synthesizer',
  'Neumann U 87',
  'ProCo Rat',
  'Roland Juno 106',
  'Shure SM7B Microphone',
  'Strymon TimeLine',
  'Taylor GS Mini',
  'Teenage Engineering OP-1',
  'Universal Audio Apollo Twin',
  'Vox AC30',
  'Yamaha DX7',
  'Zildjian New Beat Hi-Hats',
];

export const DEFAULT_URL = CORE_MARKETPLACE_URL;
export const DEFAULT_PLACEHOLDER = I18n.t('commons.searchHeader.placeholder');

interface IState {
  defaultValue: string;
}

interface IProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  secondaryImageUrl?: string;
  searchPlaceholder?: string;
  actionText?: string;
  actionUrl?: string;
  renderSearchSuggestion?: boolean;
}

@track({ componentName: 'SearchHeader' })
export class SearchHeader extends React.PureComponent<IProps & IUserContext, IState> {
  state = {
    defaultValue: randSample(this.props.user.requestId, defaultValues),
  };

  renderSuggestion() {
    if (!this.props.renderSearchSuggestion) return;

    return (
      <CoreLink
        className="search-header__suggestion"
        to={marketplaceQuery(this.state.defaultValue)}
        interactionType="clickSuggestion"
      >
        <SanitizedRender
          html={I18n.t('commons.searchHeader.suggestion', {
            suggestion: this.state.defaultValue,
            tagOpen: '<b>',
            tagClose: '</b>',
          })}
        />
      </CoreLink>
    );
  }

  getPrimaryBackgroundImage() {
    return { backgroundImage: `url('${this.props.imageUrl}')` };
  }

  getMobileBackgroundImage() {
    return { backgroundImage: `url('${this.props.secondaryImageUrl}')` };
  }

  renderBackgroundImage() {
    if (this.props.secondaryImageUrl) {
      return (
        <>
          <div
            className="search-header__bg-image search-header__bg-image--desktop"
            style={this.getPrimaryBackgroundImage()}
          />
          <div
            className="search-header__bg-image search-header__bg-image--mobile"
            style={this.getMobileBackgroundImage()}
          />
        </>
      );
    }
    return (
      <div
        className="search-header__bg-image"
        style={this.getPrimaryBackgroundImage()}
      />
    );
  }

  renderAction() {
    if (!this.props.actionText) {
      return (
        <CMSSearchInputGroup
          actionUrl={this.props.actionUrl || DEFAULT_URL}
          placeholder={this.props.searchPlaceholder || DEFAULT_PLACEHOLDER}
          largeInput
        />
      );
    }

    return (
      <CoreLink
        to={this.props.actionUrl || DEFAULT_URL}
        className="button button--large"
      >
        {this.props.actionText}
      </CoreLink>
    );
  }

  render() {
    return (
      <div className="search-header">
        {this.renderBackgroundImage()}
        <div className="search-header__inner">
          <div className="search-header__text">
            <h2>
              {this.props.subtitle}
            </h2>
            <h1>
              {this.props.title}
            </h1>
            <div className="search-header__input">
              {this.renderAction()}
              {this.renderSuggestion()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withUserContext(SearchHeader);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/cms/headers/search_header.tsx